import axios from "axios";
import { useEffect, useState } from "react";
import { useLoader } from "../useLoader";


export type currencyType = {
    currency: string,
    rate: number
}


export const useGetCurrencyRates = () => {
    const [currencyRates, setCurrencyRates] = useState<currencyType[]>([]);
    const loader = useLoader();

    const fetchCurrencyRates = async () => {

        loader?.setIsLoading(true);
        try {
            const responseData = await axios.get("https://openexchangerates.org/api/latest.json?app_id=178e2ec246d94cf39384d34c464daec6"); 
            const rates = responseData.data.rates;

            const currencies:currencyType[] = []
            Object.keys(rates).map((key:any) => {
                currencies.push({"currency":key, "rate": rates[key]});
            });
            
            setCurrencyRates(currencies);
            loader?.setIsLoading(false);
        } catch (error) {
            loader?.setIsLoading(false);
            return null;
        }
    }

    useEffect(() => {
        fetchCurrencyRates();
    }, []);

    return { currencyRates, setCurrencyRates };
}